import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { dictionaries, LANGUAGES } from "@/locales";

const I18nContext = createContext(null);
const STORAGE_KEY = "gpu-lang";

const resolve = (dict, path) =>
  path.split(".").reduce((acc, key) => (acc == null ? undefined : acc[key]), dict);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem(STORAGE_KEY) || "en");

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang === "gu" ? "gu-IN" : "en-IN";
  }, [lang]);

  const value = useMemo(() => {
    const dict = dictionaries[lang] || dictionaries.en;
    const t = (path, vars) => {
      const found = resolve(dict, path);
      if (found === undefined) return path;
      if (typeof found === "string" && vars) {
        return Object.keys(vars).reduce((s, k) => s.replace(`{${k}}`, vars[k]), found);
      }
      return found;
    };
    return { lang, setLang, t, languages: LANGUAGES };
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
  return ctx;
};
